import PropTypes from "prop-types";
import React from "react";

function InformationBox({ title, icon, content }) {
  return (
    <div className="col-md-12 heading-home-bottom">
      <div className="bottom-heading">
        <span className="headingicon">
          <i className={icon} aria-hidden="true"></i>
        </span>
        {title}
      </div>
      {content}
    </div>
  );
}

InformationBox.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
};

export default InformationBox;
